import type { FeedbackMessages } from './en';

const sw: FeedbackMessages = {
  qualified: {
    title: 'Asante kwa kukamilisha utafiti huu!',
    body1: 'Unaweza kufunga dirisha la kivinjari.',
    body2: 'Tunatarajia kukuona tena hivi karibuni.',
    refCode: 'Nambari ya Marejeleo: {code}',
  },
  quotaFull: {
    title: 'Utafiti huu umefungwa',
    body1: 'Asante kwa kupendezwa na utafiti wetu.',
    body2: 'Kwa bahati mbaya, tayari tumepokea majibu yote tunayohitaji.',
    body3: 'Tunatarajia kukuona katika mojawapo ya utafiti wetu wa siku zijazo!',
    refCode: 'Nambari ya Marejeleo: {code}',
  },
  terminated: {
    title: 'Asante kwa kutoa maoni yako!',
    body1:
      'Tunatarajia kukuona hivi karibuni katika utafiti wetu wa siku zijazo. Hadi wakati huo, tunakutakia siku njema.',
    body2: 'Tafadhali funga dirisha hili la kivinjari.',
    refCode: 'Nambari ya Marejeleo: {code}',
  },
  mismatch: {
    title: 'Asante kwa kupendezwa kwako',
    body1: 'Kwa bahati mbaya, hauko katika kundi lengwa kwa utafiti huu maalum.',
    body2: 'Unaweza kufunga ukurasa huu.',
    code: 'Nambari: {code}',
  },
  error: {
    title: 'Hatuwezi kushughulikia ombi lako',
    linkProblemDetailed:
      'Kiungo ulichofuata kina matatizo. Tafadhali hakikisha kwamba kiungo kilichopo kwenye sehemu ya anwani kinafanana na kile ulichopewa, kisha jaribu tena.',
    linkProblemGeneric: 'Kiungo ulichofuata kina matatizo. Tafadhali jaribu tena.',
    contactPerson:
      'Iwapo tatizo litaendelea, tafadhali mjulishe mtu uliyempata kiungo kutoka kwake kuhusu tatizo hili.',
    errorCode: 'Nambari ya Hitilafu: {code}',
  },
};

export default sw;
